function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function _createForOfIteratorHelper(r, e) {
  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (!t) {
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
      t && (r = t);
      var _n = 0,
        F = function F() {};
      return {
        s: F,
        n: function n() {
          return _n >= r.length ? {
            done: !0
          } : {
            done: !1,
            value: r[_n++]
          };
        },
        e: function e(r) {
          throw r;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var o,
    a = !0,
    u = !1;
  return {
    s: function s() {
      t = t.call(r);
    },
    n: function n() {
      var r = t.next();
      return a = r.done, r;
    },
    e: function e(r) {
      u = !0, o = r;
    },
    f: function f() {
      try {
        a || null == t["return"] || t["return"]();
      } finally {
        if (u) throw o;
      }
    }
  };
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var saito = require('./../../../lib/saito/saito');
var TweetTemplate = require('./tweet.template');
var SaitoUser = require('./../../../lib/saito/ui/saito-user/saito-user');
var Link = require('./../../../lib/saito/ui/saito-link/link');
var Image = require('./image');
var Post = require('./post');
var JSON = require('json-bigint');
var Transaction = require('../../../lib/saito/transaction')["default"];
var Tweet = /*#__PURE__*/function () {
  function Tweet(app, mod, tx) {
    var _this$tx, _this$images;
    var container = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '.tweet-container';
    _classCallCheck(this, Tweet);
    this.app = app;
    this.mod = mod;
    this.container = container;
    this.name = 'Tweet';
    this.tx = tx;

    //
    // skip null txs
    //
    if (!tx) {
      console.error('Creating tweet with invalid transaction', tx);
      return null;
    }
    var txmsg = tx.returnMessage();

    //
    // skip non-redsquare txs
    //
    if (txmsg.module !== mod.name) {
      console.error('Creating tweet with invalid transaction : ', txmsg);
      return null;
    }

    //
    // ancillary content is stored in the tx.optional array, where it
    // can be saved back to the network of archive nodes / databases and
    // preserved along with the transaction as optional (unverified) but
    // associated content.
    //
    // since this information includes meta-data such as the number of
    // replies, retweets, likes, and open graph information, we set the
    // variables to nothing if we receive transactions without the info
    //
    if (!this.tx.optional) {
      this.tx.optional = {};
    }
    if (!this.tx.optional.num_replies) {
      this.tx.optional.num_replies = 0;
    }
    if (!this.tx.optional.num_retweets) {
      this.tx.optional.num_retweets = 0;
    }
    if (!this.tx.optional.num_likes) {
      this.tx.optional.num_likes = 0;
    }
    if (!this.tx.optional.link_properties) {
      this.tx.optional.link_properties = null;
    }
    if (!this.tx.optional.retweeters) {
      this.tx.optional.retweeters = [];
    }
    // thread_id / parent_id

    //
    // additional variables are created in-memory from the core transaction
    // without the need for re-saving, these are specified below.
    //
    this.text = '';
    this.youtube_id = null;
    this.created_at = this.tx.timestamp;
    this.updated_at = ((_this$tx = this.tx) === null || _this$tx === void 0 ? void 0 : _this$tx.updated_at) || this.tx.timestamp;

    //
    // is this tweet curated
    //
    this.curated = tx.isFrom(mod.publicKey) ? 1 : 0;

    //
    // the notice shows up at the top of the tweet BEFORE the username and
    // is used for "retweeted by X" or "liked by Y". the userline is the
    // line that goes in the tweet header below the username/address but to
    // the right of the identicon.
    //
    this.notice = '';
    this.user = new SaitoUser(app, mod, this.container + "> .tweet-".concat(this.tx.signature, " .tweet-body .tweet-header"), this.tx.from[0].publicKey);

    //
    // set defaults
    //
    this.children = [];
    this.children_sigs_hmap = {};
    this.critical_child = null;
    this.force_long_tweet = false;
    this.is_long_tweet = false;
    this.link = null;
    this.parent_id = '';
    this.thread_id = this.tx.signature;
    this.render_after_selector = ''; //Used to attach replies to the original tweet
    this.retweet = null;
    this.retweet_tx = null;
    this.show_controls = 1;
    this.unknown_children = [];
    this.unknown_children_sigs_hmap = {};
    this.user.notice = 'new post on ' + this.formatDate();
    this.tree_size = 1;
    this.reply_class = '';

    // Keep a running list of where/when we load this tweet (updated by addTweet)
    // type / node / optional / ts
    this.sources = [];

    //
    // transactions can contain more specifi information for
    // all of the above variables. so we run a function that
    // attempts to extract them if they exist.
    //
    try {
      this.setKeys(txmsg.data, true);
    } catch (err) {
      console.error('ERROR in Tweet.js (1):', err);
    }
    //
    // tx.optional can override any original values in the signed tweet!
    //
    try {
      this.setKeys(tx.optional, true);
    } catch (err) {
      console.error('ERROR in Tweet.js (2):', err);
    }

    //
    // update (if edited)
    //
    if (this.update_tx) {
      var newtx = new Transaction();
      newtx.deserialize_from_web(this.app, this.update_tx);
      var newtxmsg = newtx.returnMessage();
      this.text = newtxmsg.data.text;
    }
    if (this.tx.optional.num_replies > 0) {
      this.user.notice = 'originally posted on ' + this.formatDate();
    }

    //
    // embedded links
    //
    this.analyseTweetLinks(0);

    //
    // retweets
    //
    if (this.retweet_tx != null) {
      var _newtx = new Transaction();
      _newtx.deserialize_from_web(this.app, this.retweet_tx);
      this.retweet = new Tweet(this.app, this.mod, _newtx, this.container + "> .tweet-".concat(this.tx.signature, " .tweet-body .tweet-retweet"));
      this.retweet.show_controls = 0;
    }

    //
    // image preview
    //
    if (((_this$images = this.images) === null || _this$images === void 0 ? void 0 : _this$images.length) > 0) {
      this.img_preview = new Image(this.app, this.mod, this.container + "> .tweet-".concat(this.tx.signature, " .tweet-body .tweet-image"), this.images, this.tx.signature);
    }

    //
    // use as flag to indicate no errors in constructor
    //
    this.noerrors = true;
  }
  return _createClass(Tweet, [{
    key: "isPost",
    value: function isPost() {
      var txmsg = this.tx.returnMessage();
      if (txmsg.request != 'create tweet') {
        return false;
      }
      if (this.parent_id == '') {
        return true;
      }
      return false;
    }
  }, {
    key: "isReply",
    value: function isReply() {
      var txmsg = this.tx.returnMessage();
      if (txmsg.request != 'create tweet') {
        return false;
      }
      if (this.parent_id != '') {
        return true;
      }
      return false;
    }
  }, {
    key: "isRetweet",
    value: function isRetweet() {
      var _txmsg$data, _txmsg$data2;
      var txmsg = this.tx.returnMessage();
      if (txmsg.request != 'create tweet') {
        return false;
      }
      if (!((_txmsg$data = txmsg.data) !== null && _txmsg$data !== void 0 && _txmsg$data.text) && !((_txmsg$data2 = txmsg.data) !== null && _txmsg$data2 !== void 0 && _txmsg$data2.images)) {
        return true;
      }
      return false;
    }
  }, {
    key: "formatDate",
    value: function formatDate() {
      var ts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      var submit_ts = ts || this.created_at;
      var dt = this.app.browser.formatDate(submit_ts);
      return "".concat(dt.month, " ").concat(dt.day, ", ").concat(dt.year, " at ").concat(dt.hours, ":").concat(dt.minutes);
    }

    //
    //  This is helpful when pulling older tweets and then running through the whole list of tweets
    //
  }, {
    key: "isRendered",
    value: function isRendered() {
      if (!this.app.BROWSER) {
        return false;
      }
      if (document.querySelector(".tweet-container > .tweet-".concat(this.tx.signature))) {
        return true;
      }
      return false;
    }

    /**
     * A simple, recursive test to see if we have the entire tweet thread/tree in memory
     */
  }, {
    key: "isLoaded",
    value: function isLoaded() {
      if (this.loaded) {
        return true;
      }
      if (this.num_replies > this.children.length) {
        return false;
      } else if (this.num_replies < this.children.length) {
        this.num_replies = this.children.length;
      }
      this.loaded = true;
      for (var i = 0; i < this.children.length; i++) {
        if (!this.children[i].isLoaded()) {
          this.loaded = false;
        }
      }
      return this.loaded;
    }
  }, {
    key: "hideTweet",
    value: function hideTweet() {
      //remove from archive
      this.app.storage.deleteTransaction(this.tx, null, 'localhost');

      //remove from dom
      this.remove();

      //Add to blacklist
      this.mod.hidden_tweets.push(this.tx.signature);
      this.mod.saveOptions();
      this.curated = -1;
    }
  }, {
    key: "replace",
    value: function replace(target_tweet) {
      if (this.app.BROWSER) {
        var eqs = ".tweet-".concat(target_tweet.tx.signature);
        if (document.querySelector(eqs)) {
          this.app.browser.replaceElementBySelector(TweetTemplate(this.app, this.mod, this, false), eqs);
          this.render();
        }
      }
    }
  }, {
    key: "remove",
    value: function remove() {
      if (!this.app.BROWSER) {
        return;
      }
      var eqs = ".tweet-".concat(this.tx.signature);
      if (document.querySelector(eqs)) {
        document.querySelector(eqs).remove();
      }
      if (this.parent_id) {
        var parent = this.mod.returnTweet(this.parent_id);
        if (parent.isRendered()) {
          parent.removeReply();
        }
      }
    }
  }, {
    key: "removeReply",
    value: function removeReply() {
      var myqs = this.container + "> .tweet-".concat(this.tx.signature);
      var obj = document.querySelector(myqs);
      if (obj) {
        obj.classList.remove(this.reply_class);
      }
      this.reply_class = '';
    }
  }, {
    key: "render",
    value: function render() {
      var _this$retweeters, _this$tx$optional2;
      var prepend = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var _iterator = _createForOfIteratorHelper(this.mod.peers),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var peer = _step.value;
          if (this.tx.isFrom(peer.publicKey)) {
            this.force_long_tweet = true;
          }
        }

        //
        // create link preview if link
        //
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      if (this.link_properties && !this.link_preview) {
        this.link_preview = new Link(this.app, this.mod, this.container + "> .tweet-".concat(this.tx.signature, " .tweet-body .tweet-link-preview"), this.link, this.link_properties);
      }

      //
      // in the case of a quote-or-retweet the retweet might appear on the same page
      // as the original tweet, so we check here and flag whether or not the element
      // already exists. if it does we will only render 1.
      //
      var myqs = this.container + "> .tweet-".concat(this.tx.signature);

      //
      // if prepend = true, remove existing element
      //
      if (prepend) {
        var obj = document.querySelector(myqs);
        if (obj) {
          obj.remove();
        }
      }

      //
      // if this is a retweet but not a quote tweet we pass through the "parent" and just
      // render the child with a "retweet-notice" that shows up at the top of the tweet. we
      // then pass-through and render the sub-tweet directly.
      //
      if (this.retweet_tx && !this.text && !this.img_preview) {
        this.reply_class = '';
        this.retweet.notice = 'retweeted by ' + this.app.browser.returnAddressHTML(this.tx.from[0].publicKey) + ' ' + this.formatDate(this.retweet_tx.timestamp);
        this.retweet.container = '.tweet-container';
        var t = this.mod.returnTweet(this.retweet.tx.signature);
        if (t) {
          t.notice = this.retweet.notice;
          t.user.notice = t.user.notice.replace('new', 'original');
          t.render(prepend);
          t.user.render();
          t.attachEvents();
        } else {
          this.retweet.user.container = this.container + "> .tweet-".concat(this.retweet.tx.signature, " .tweet-body .tweet-header");
          this.retweet.user.notice = this.retweet.user.notice.replace('new', 'original');
          this.retweet.render(prepend);
          this.retweet.user.render();
          this.retweet.attachEvents();
        }
        return 0;
      }

      //
      // New way for retweets we don't put the new ones in the feed, just update the originals and sort them higher up
      //
      if (((_this$retweeters = this.retweeters) === null || _this$retweeters === void 0 ? void 0 : _this$retweeters.length) > 0 && this.container == '.tweet-container') {
        var _this$tx$optional;
        this.notice = "retweeted by ".concat(this.app.browser.returnAddressHTML(this.retweeters[0]), " ").concat(this.formatDate((_this$tx$optional = this.tx.optional) === null || _this$tx$optional === void 0 ? void 0 : _this$tx$optional.retweeted_at));
      }
      if (this.tx.isTo(this.mod.publicKey) && !this.tx.isFrom(this.mod.publicKey)) {
        var _this$mentions;
        if (this.mentions == 1 || (_this$mentions = this.mentions) !== null && _this$mentions !== void 0 && _this$mentions.includes(this.mod.publicKey)) {
          this.notice = 'you were mentioned in this tweet';
        }
      }
      if ((_this$tx$optional2 = this.tx.optional) !== null && _this$tx$optional2 !== void 0 && _this$tx$optional2.update_tx) {
        this.notice = 'this tweet was edited on ' + this.formatDate(this.tx.optional.update_tx.timestamp);
      }

      //>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>
      if (this.render_after_selector) {
        console.log('!!!!!!! ' + this.render_after_selector);
        //
        // remove if selector does not exist
        //
        if (!document.querySelector(this.render_after_selector)) {
          console.warn('!!!!!!!!! !document.querySelector(this.render_after_selector)');
          this.render_after_selector = '';
        }
        //
        // remove if selector is a previewed tweet, like retweet
        //
        var preview_selector = '.tweet-preview ' + this.render_after_selector;
        if (document.querySelector(preview_selector)) {
          console.warn('!!!!!!!!! document.querySelector(preview_selector)');
          //
          //
          //
          this.render_after_selector = '';
        }
      }
      if (document.querySelector(myqs)) {
        this.app.browser.replaceElementBySelector(TweetTemplate(this.app, this.mod, this), myqs);
      } else if (prepend) {
        this.app.browser.prependElementToSelector(TweetTemplate(this.app, this.mod, this), this.container);
      } else if (this.render_after_selector) {
        this.app.browser.addElementAfterSelector(TweetTemplate(this.app, this.mod, this), this.render_after_selector);
      } else {
        this.app.browser.addElementToSelector(TweetTemplate(this.app, this.mod, this), this.container);
      }

      //
      // modify width of any iframe
      //
      if (this.youtube_id != null && this.youtube_id != 'null') {
        var tbqs = myqs + ' .tweet-body .tweet-text';
        var ytqs = myqs + ' .tweet-body .tweet-text .youtube-embed';
        if (document.querySelector(tbqs)) {
          var x = document.querySelector(tbqs).getBoundingClientRect();
          var y = document.querySelector(ytqs);
          if (x) {
            if (y) {
              y.style.width = Math.floor(x.width) + 'px';
              y.style.height = Math.floor(x.width / 16 * 9) + 'px';
            }
          }
        }
      }
      this.user.render();
      if (this.img_preview != null) {
        this.img_preview.render();
      }

      // Render Quote tweet
      if (this.retweet) {
        this.retweet.render();
      }
      if (this.link_preview != null) {
        if (this.tx.optional.link_properties != null) {
          if (Object.keys(this.tx.optional.link_properties).length > 0) {
            this.link_preview.render();
          }
        }
      }
      this.attachEvents();
      return 1;
    }
  }, {
    key: "rerenderControls",
    value: function rerenderControls() {
      var complete_rerender = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      if (!this.app.BROWSER || !this.mod.browser_active) {
        return;
      }
      if (!this.isRendered()) {
        return;
      }

      //console.log('Update Tweet stats...');

      this.setKeys(this.tx.optional);
      if (complete_rerender) {
        this.render();
      } else {
        // like, retweet, comment
        var rep = this.num_replies;
        if (this.rethread) {
          rep += this.tree_size - 1;
        }
        this.refreshStat('like', this.num_likes);
        this.refreshStat('retweet', this.num_retweets);
        this.refreshStat('comment', rep);
      }
    }
  }, {
    key: "forceRenderWithCriticalChild",
    value: function forceRenderWithCriticalChild() {
      if (this.critical_child) {
        if (this.critical_child.parent_id == this.tx.signature) {
          this.reply_class = 'has-reply';
        } else {
          this.reply_class = 'has-reply-disconnected';
        }
        this.render();
        this.critical_child.render_after_selector = '.tweet-' + this.tx.signature;
        this.critical_child.reply_class = '';
        if (this.critical_child.render() == -1) {
          this.removeReply();
        }
      } else {
        this.render();
      }
      this.attachEvents();
    }

    //
    // for rendering the tweet on the main page
    //
  }, {
    key: "renderWithCriticalChild",
    value: function renderWithCriticalChild() {
      if (this.isRendered()) {
        return;
      }

      //
      // then we render any critical children
      //
      if (this.critical_child && !this.critical_child.isRendered()) {
        if (this.critical_child.parent_id == this.tx.signature) {
          this.reply_class = 'has-reply';
        } else {
          this.reply_class = 'has-reply-disconnected';
        }
        this.render();
        this.critical_child.render_after_selector = '.tweet-' + this.tx.signature;
        this.critical_child.reply_class = '';
        if (this.critical_child.render() > 0) {
          //
          // if no replies are listed, but we are showing a reply... show least one to avoid confusion
          //
          if (this.tx.optional.num_replies == 0) {
            var obj = document.querySelector(".tweet-".concat(this.tx.signature, " .tweet-controls .tweet-tool-comment .tweet-tool-comment-count"));
            try {
              if (obj) {
                obj.innerHTML = '1';
              }
            } catch (err) {
              console.error('RS.tweet ERROR: ', err);
            }
          }
        }
      } else {
        this.render();
      }
      this.attachEvents();
    }
  }, {
    key: "renderWithChildren",
    value: function renderWithChildren() {
      var recurse = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      console.debug('renderWithChildren');
      if (this.children.length == 1 && recurse) {
        this.reply_class = 'has-reply';
      }

      //
      // first render the tweet
      //
      this.render();

      //
      // then render its children
      //
      // it's clear we need to figure out tweet threading....
      //
      if (this.children.length > 0) {
        //
        // Breadth -- Show all replies at one level
        //
        if (this.children.length > 1 || !recurse) {
          for (var i = 0; i < this.children.length; i++) {
            this.children[i].container = this.container;
            this.children[i].render_after_selector = ".tweet-".concat(this.tx.signature);
            this.children[i].renderChild();
          }
        } else {
          //
          // Depth -- Recurse down through tweet thread
          //
          this.children[0].container = this.container;
          this.children[0].render_after_selector = ".tweet-".concat(this.tx.signature);
          this.children[0].renderWithChildren();
        }
      }
      this.attachEvents();
    }
  }, {
    key: "renderNullTweet",
    value: function renderNullTweet() {
      var html = "<div class=\"tweet tweet-".concat(this.tx.signature, " is-reply null-tweet\">\n          <div class=\"tweet-body\">\n            <div class=\"tweet-text\">filtered tweet not shown</div>\n          </div>\n        </div>");
      this.app.browser.addElementAfterSelector(html, this.render_after_selector);
    }
  }, {
    key: "renderChild",
    value: function renderChild() {
      this.reply_class = 'is-reply';
      if (this.render() == -1) {
        this.renderNullTweet();
      }
    }

    //
    // This function renders the tweet thread from `this` to tweet, but selecting the child
    // at each step which is part of the thread (as expressed in the array sigs)
    //
  }, {
    key: "renderWithChildrenWithTweet",
    value: function renderWithChildrenWithTweet(tweet) {
      var sigs = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
      if (!tweet) {
        console.warn('no tweet!');
        return -1;
      }

      //
      // render this tweet
      //
      if (sigs.includes(this.tx.signature)) {
        this.force_long_tweet = true;

        // We have reached the target tweet, so now show all of it's immediate children...
        if (this.tx.signature == tweet.tx.signature) {
          this.renderWithChildren();
        } else {
          if (this.children.length) {
            this.reply_class = 'has-reply';
          }
          this.render();

          //
          // then render children
          //
          if (this.children.length > 0) {
            for (var i = 0; i < this.children.length; i++) {
              this.children[i].container = this.container;
              this.children[i].render_after_selector = ".tweet-".concat(this.tx.signature);
              if (sigs.includes(this.children[i].tx.signature)) {
                this.children[i].renderWithChildrenWithTweet(tweet, sigs);
              }
            }
          }
        }
        this.attachEvents();
      } else {
        console.warn('this tweet not in the thread sigs....');
        console.log(sigs);
      }
    }
  }, {
    key: "attachEvents",
    value: function attachEvents() {
      var _this = this;
      var mod = this.mod;
      var app = this.app;
      if (this.show_controls == 0 && !this.rethread) {
        return;
      }
      try {
        //
        // tweet does not exist? exit
        //
        var this_tweet = document.querySelector(".tweet-".concat(this.tx.signature));
        if (!this_tweet) {
          return;
        }

        /////////////////////////////
        // Expand / Contract Tweet //
        /////////////////////////////
        //
        // if you don't want a tweet to auto-contract on display, set this.is_long_tweet
        // to be true before running attachEvents(); this will avoid it getting compressed
        // with expanded / preview toggle.
        //
        var tweet_text = document.querySelector(".tweet-".concat(this.tx.signature, " .tweet-body .tweet-text"));
        if (tweet_text) {
          if (this.force_long_tweet) {
            tweet_text.classList.add('expanded');
          } else {
            if (tweet_text.clientHeight < tweet_text.scrollHeight - 1) {
              tweet_text.classList.add('preview');
              this.is_long_tweet = true;
            }
          }
        }
        if (document.querySelector(".tweet-".concat(this.tx.signature, " .tweet-curation-controls"))) {
          if (document.querySelector(".tweet-".concat(this.tx.signature, " .tweet-curation-controls #hide-spam"))) {
            document.querySelector(".tweet-".concat(this.tx.signature, " .tweet-curation-controls #hide-spam")).onclick = function (e) {
              e.stopPropagation();
              _this.hideTweet();
              siteMessage('Thank you for your feedback!', 3000);
            };
          }
          if (document.querySelector(".tweet-".concat(this.tx.signature, " .tweet-curation-controls #approve-tweet"))) {
            document.querySelector(".tweet-".concat(this.tx.signature, " .tweet-curation-controls #approve-tweet")).onclick = function (e) {
              e.stopPropagation();
              _this.curation_check = _this.tx.optional.curation_check = false;
              _this.tx.optional.curated = 1;
              _this.mod.saveTweet(_this);
              _this.rerenderControls(true);
              siteMessage('Thank you for your feedback!', 3000);
            };
          }
          if (document.querySelector(".tweet-".concat(this.tx.signature, " .tweet-curation-controls #approve-user"))) {
            document.querySelector(".tweet-".concat(this.tx.signature, " .tweet-curation-controls #approve-user")).onclick = function (e) {
              e.stopPropagation();
              _this.curation_check = _this.tx.optional.curation_check = false;
              _this.tx.optional.curated = 1;
              _this.mod.saveTweet(_this);
              _this.rerenderControls(true);
              siteMessage('Thank you for your feedback!', 3000);
            };
          }
        }

        /////////////////
        // view thread //
        /////////////////
        if (!this_tweet.dataset.hasClickEvent) {
          this_tweet.dataset.hasClickEvent = true;
          this_tweet.onclick = function (e) {
            //
            // if we have selected text, then we are trying to copy and paste and
            // the last thing we want is for the UI to update and prevent us from
            // being able to use the site.
            //
            var highlightedText = '';
            if (window.getSelection) {
              highlightedText = window.getSelection().toString();
            } else if (document.selection && document.selection.type != 'Control') {
              highlightedText = document.selection.createRange().text;
            }
            if (highlightedText != '') {
              console.log("highlighting text, don't open thread");
              return;
            }

            //
            // Expand tweet preview for long tweets -- click once to expand, again to view thread
            //
            if (_this.is_long_tweet && tweet_text !== null && tweet_text !== void 0 && tweet_text.classList.contains('preview')) {
              tweet_text.classList.remove('preview');
              tweet_text.classList.add('expanded');
              _this.force_long_tweet = true;
              console.log('expanding long tweet');
              return;
            }
            if (_this.curation_check) {
              console.log('curation check tweet');
              return;
            }

            //
            // if we are asking to see a tweet, WE SHOULD load from parent if exists
            //
            if (e.target.tagName != 'IMG') {
              if (!_this.thread_sigs) {
                _this.thread_sigs = _this.mod.returnThreadSigs(_this.tx.signature);
              }
              //
              // full thread already exists
              //
              if (_this.thread_sigs.includes(_this.tx.signature) && _this.thread_sigs.includes(_this.thread_id)) {
                app.connection.emit('redsquare-tweet-render-request', _this);
              } else {
                navigateWindow("/redsquare?tweet_id=".concat(_this.thread_id), 300);
              }
            }
          };
        }

        ////////////////////////////////////////////////
        // view preview  -- click on the embedded post in a quote-tweet
        ////////////////////////////////////////////////
        document.querySelectorAll(".tweet-".concat(this.tx.signature, " .tweet")).forEach(function (item) {
          item.addEventListener('click', function (e) {
            e.stopImmediatePropagation();
            var sig = item.getAttribute('data-id');
            if (e.target.tagName != 'IMG' && sig) {
              var t = _this.mod.returnTweet(sig);
              if (t) {
                app.connection.emit('redsquare-tweet-render-request', t);
              } else {
                console.warn('RS.tweet -- This is going to screw up the feed');
                //this.retweet.container = '.tweet-container';
                app.connection.emit('redsquare-tweet-render-request', _this.retweet);
              }
            }
          });
        });

        ///////////
        // reply //
        ///////////
        var reply = document.querySelector(".tweet-".concat(this.tx.signature, " .tweet-body .tweet-controls .tweet-tool-comment"));
        if (reply) {
          reply.onclick = function (e) {
            e.preventDefault();
            e.stopImmediatePropagation();
            var post = new Post(_this.app, _this.mod, _this);
            post.type = 'Reply';
            post.render();
            _this.app.browser.prependElementToSelector("<div id=\"post-tweet-preview-".concat(_this.tx.signature, "\" class=\"post-tweet-preview\" data-id=\"").concat(_this.tx.signature, "\"></div>"), '.saito-overlay .tweet-overlay');

            //
            //Show quoted tweet in the post
            //
            var newtx = new Transaction(undefined, _this.tx.toJson());
            newtx.signature = _this.app.crypto.hash(_this.tx.signature) + _this.app.crypto.hash(_this.tx.signature);
            var new_tweet = new Tweet(_this.app, _this.mod, newtx, "#post-tweet-preview-".concat(_this.tx.signature));
            new_tweet.show_controls = 0;
            new_tweet.render();
            document.querySelector('#post-tweet-textarea').focus();
          };
        }

        /////////////
        // retweet //
        /////////////
        var retweet = document.querySelector(".tweet-".concat(this.tx.signature, " .tweet-body .tweet-controls .tweet-tool-retweet"));
        if (retweet) {
          retweet.onclick = function (e) {
            e.preventDefault();
            e.stopImmediatePropagation();
            var post = new Post(_this.app, _this.mod, _this);
            post.type = 'Retweet';
            post.render();
            _this.app.browser.prependElementToSelector("<div id=\"post-tweet-preview-".concat(_this.tx.signature, "\" class=\"post-tweet-preview\" data-id=\"").concat(_this.tx.signature, "\"></div>"), '.saito-overlay .tweet-overlay');

            //Insert this tweet as a new Tweet in the post window
            var newtx = new Transaction(undefined, _this.tx.toJson());
            newtx.signature = _this.app.crypto.hash(_this.tx.signature) + _this.app.crypto.hash(_this.tx.signature);
            var new_tweet = new Tweet(_this.app, _this.mod, newtx, "#post-tweet-preview-".concat(_this.tx.signature));
            new_tweet.show_controls = 0;
            new_tweet.render();
          };
        }

        //////////
        // like //
        //////////
        var heartIcon = document.querySelector(".tweet-".concat(this.tx.signature, " .heart-icon"));
        if (heartIcon) {
          heartIcon.onclick = /*#__PURE__*/function () {
            var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(e) {
              var obj;
              return _regenerator().w(function (_context) {
                while (1) switch (_context.n) {
                  case 0:
                    if (!heartIcon.classList.contains('liked')) {
                      heartIcon.classList.add('likes');
                      _this.mod.likeTweet(_this);
                    }
                    e.preventDefault();
                    e.stopImmediatePropagation();
                    _context.n = 1;
                    return _this.mod.sendLikeTransaction(_this.app, _this.mod, {
                      signature: _this.tx.signature
                    }, _this.tx);
                  case 1:
                    //
                    // increase num likes
                    //
                    obj = document.querySelector(".tweet-".concat(_this.tx.signature, " .tweet-body .tweet-controls .tweet-tool-like .tweet-tool-like-count"));
                    if (obj) {
                      obj.innerHTML = parseInt(obj.innerHTML) + 1;
                      if (!obj.classList.contains('liked')) {
                        obj.classList.add('liked');
                      }
                    }
                  case 2:
                    return _context.a(2);
                }
              }, _callee);
            }));
            return function (_x) {
              return _ref.apply(this, arguments);
            };
          }();
        }

        ///////////
        // share //
        ///////////
        var share = document.querySelector(".tweet-".concat(this.tx.signature, " .tweet-body .tweet-controls .tweet-tool-share"));
        if (share) {
          share.onclick = function (e) {
            e.preventDefault();
            e.stopImmediatePropagation();
            var tweetUrl = window.location.origin + window.location.pathname + '?tweet_id=' + _this.tx.signature;
            _this.app.browser.handleShare({
              title: 'Saito Redsquare Post',
              url: tweetUrl
            });

            /*navigator.clipboard.writeText(tweetUrl).then(() => {
            	siteMessage('Link copied to clipboard.', 2000);
            });*/
          };
        }
        var more = document.querySelector(".tweet-".concat(this.tx.signature, " .tweet-body .tweet-controls .tweet-tool-more"));
        if (more) {
          more.onclick = function (e) {
            e.preventDefault();
            e.stopImmediatePropagation();
            e.currentTarget.classList.add('activated-dot-menu');
            _this.app.connection.emit('redsquare-show-tweet-options', _this, more);
          };
        }

        // Don't bubble up from misclicking outside of the like/comment space
        if (document.querySelector(".tweet-".concat(this.tx.signature, " .tweet-body .tweet-controls"))) {
          document.querySelector(".tweet-".concat(this.tx.signature, " .tweet-body .tweet-controls")).onclick = function (e) {
            e.stopPropagation();
            e.preventDefault();
          };
        }
      } catch (err) {
        console.error('RS.Tweet -- ERROR attaching events to tweet: ', err);
      }
    }

    //
    // I am using this function to reset the this.num_likes, etc
    // from an updated tx that we either received on chain or through an archive query
    // (both of which manually increment the stats in tx.optional)
    //
  }, {
    key: "setKeys",
    value: function setKeys(obj) {
      var force = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      for (var key in obj) {
        if (typeof obj[key] !== 'undefined') {
          if (typeof this[key] === 'number') {
            this[key] = Math.max(this[key], obj[key]);
          } else if (!this[key] || force) {
            this[key] = obj[key];
          }
        }
      }
    }

    //
    // Add the given tweet somewhere, it may be a reply or a reply to a reply
    //
    // Todo --- Sorting of how we add children!!!!
    //
  }, {
    key: "addTweet",
    value: function addTweet(tweet) {
      this.tree_size++;
      this.updated_at = Math.max(this.updated_at, tweet.updated_at);

      //
      // if this tweet is the parent-tweet of a tweet we have already downloaded
      // and indexed here. this can happen if tweets arrive out-of-order.
      //
      for (var i = 0; i < this.unknown_children.length; i++) {
        if (this.unknown_children[i].parent_id === tweet.tx.signature) {
          //
          // tweet adds its orphan
          //
          tweet.addTweet(this.unknown_children[i]);

          //
          // and delete from unknown children
          this.removeUnknownChild(this.unknown_children[i]);
        }
      }

      //
      // tweet is direct child
      //
      if (tweet.parent_id == this.tx.signature) {
        //
        // already added?
        //
        if (this.children_sigs_hmap[tweet.tx.signature]) {
          return 0;
        }
        this.children_sigs_hmap[tweet.tx.signature] == 1;
        this.removeUnknownChild(tweet);

        //
        // make critical child if needed
        //
        if (this.isCriticalChild(tweet)) {
          this.critical_child = tweet;
        }
        if (!tweet.rethread) {
          tweet.user.notice = 'new reply on ' + this.formatDate(tweet.created_at);
        }

        //
        // prioritize tweet-threads
        //
        if (tweet.tx.from[0].publicKey === this.tx.from[0].publicKey) {
          this.children.unshift(tweet);
        } else {
          this.children.push(tweet);
        }
        return 1;

        //
        // tweet belongs to a child
        //
      } else {
        for (var _i = 0; _i < this.children.length; _i++) {
          if (this.children[_i].hasChildTweet(tweet.parent_id)) {
            this.children[_i].addTweet(tweet);
            this.children_sigs_hmap[tweet.tx.signature] = 1;
            this.removeUnknownChild(tweet);
            return 1;
          }
        }

        //
        // We failed to find the immediate parent
        //
        this.addUnknownChild(tweet);
      }
      return 1;
    }

    /////////////////////
    // query children  //
    /////////////////////
  }, {
    key: "hasChildTweet",
    value: function hasChildTweet(tweet_sig) {
      if (this.tx.signature == tweet_sig) {
        return 1;
      }
      for (var i = 0; i < this.children.length; i++) {
        if (this.children[i].hasChildTweet(tweet_sig)) {
          return 1;
        }
      }
      return this.unknown_children_sigs_hmap[tweet_sig];
    }
  }, {
    key: "returnChildTweet",
    value: function returnChildTweet(tweet_sig) {
      if (this.tx.signature == tweet_sig) {
        return this;
      }
      for (var i = 0; i < this.children.length; i++) {
        if (this.children[i].hasChildTweet(tweet_sig)) {
          return this.children[i].returnChildTweet(tweet_sig);
        }
      }
      if (this.unknown_children_sigs_hmap[tweet_sig]) {
        for (var _i2 = 0; _i2 < this.unknown_children.length; _i2++) {
          if (this.unknown_children[_i2].tx.signature == tweet_sig) {
            return this.unknown_children[_i2];
          }
        }
      }
      return null;
    }
  }, {
    key: "removeChildTweet",
    value: function removeChildTweet(tweet_sig) {
      for (var i = 0; i < this.children.length; i++) {
        if (this.children[i].tx.signature === tweet_sig) {
          this.children[i].remove();
          this.children.splice(i, 1);
          this.children_sigs_hmap[tweet_sig] = 0;
          return;
        }
      }
      if (this.unknown_children_sigs_hmap[tweet_sig]) {
        for (var _i3 = 0; _i3 < this.unknown_children.length; _i3++) {
          if (this.unknown_children[_i3].tx.signature == tweet_sig) {
            this.unknown_children[_i3].remove();
            this.unknown_children.splice(_i3, 1);
            this.unknown_children_sigs_hmap[tweet_sig] = 0;
            return;
          }
        }
      }

      //Recursive search if not already found and deleted
      for (var _i4 = 0; _i4 < this.children.length; _i4++) {
        if (this.children[_i4].hasChildTweet(tweet_sig)) {
          this.children[_i4].removeChildTweet(tweet_sig);
        }
      }
    }
  }, {
    key: "addUnknownChild",
    value: function addUnknownChild(tweet) {
      if (!this.unknown_children_sigs_hmap[tweet.tx.signature]) {
        this.unknown_children.push(tweet);
        this.unknown_children_sigs_hmap[tweet.tx.signature] = 1;
      }
    }
  }, {
    key: "removeUnknownChild",
    value: function removeUnknownChild(tweet) {
      if (this.unknown_children_sigs_hmap[tweet.tx.signature]) {
        for (var i = 0; i < this.unknown_children.length; i++) {
          if (this.unknown_children[i].tx.signature === tweet.tx.signature) {
            this.unknown_children.splice(i, 0);
            delete this.unknown_children_sigs_hmap[tweet.tx.signature];
          }
        }
      }
    }

    //
    // The critical child should be the most recent direct reply to a tweet
    // but we should prioritize our replies (better to see my snarky reply than the latest from some rando)
    //
  }, {
    key: "isCriticalChild",
    value: function isCriticalChild(tweet) {
      // Opt out for league tweets
      if (tweet.rethread) {
        return false;
      }
      var _iterator2 = _createForOfIteratorHelper(this.mod.peers),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var peer = _step2.value;
          if (tweet.tx.isFrom(peer.publicKey)) {
            if (peer.publicKey == this.mod.publicKey) {
              // My tweets! (because local is also a peer)
              return true;
            } else {
              // Server tweets
              return false;
            }
          }
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
      if (tweet.thread_id !== this.thread_id) {
        return false;
      }
      if (this.critical_child == null) {
        return true;
      }
      if (tweet.tx.isFrom(this.mod.publicKey)) {
        return true;
      }
      if (tweet.tx.timestamp > this.critical_child.tx.timestamp && !this.critical_child.tx.isFrom(this.mod.publicKey)) {
        return true;
      }
      return false;
    }
  }, {
    key: "analyseTweetLinks",
    value: function () {
      var _analyseTweetLinks = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var fetch_open_graph,
          videoId,
          url,
          urlParams,
          split,
          _this$tx$optional3,
          res,
          _args2 = arguments;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              fetch_open_graph = _args2.length > 0 && _args2[0] !== undefined ? _args2[0] : 0;
              if (this.text) {
                _context2.n = 1;
                break;
              }
              return _context2.a(2, this);
            case 1:
              this.link = this.app.browser.extractFirstValidURL(this.text);
              if (!this.link) {
                _context2.n = 4;
                break;
              }
              if (!(this.link.indexOf('youtube.com') != -1 || this.link.indexOf('youtu.be') != -1)) {
                _context2.n = 2;
                break;
              }
              videoId = '';
              if (this.link.indexOf('youtu.be') != -1) {
                videoId = this.link.split('/');
                videoId = videoId[videoId.length - 1];
              } else {
                url = new URL(this.link);
                urlParams = new URLSearchParams(url.search);
                if (urlParams) {
                  videoId = urlParams.get('v');
                }
              }

              //check for shorts
              split = this.link.split('/shorts/');
              if (typeof split[1] != 'undefined') {
                videoId = split[1];
              }

              //check for live
              split = this.link.split('/live/');
              if (typeof split[1] != 'undefined') {
                videoId = split[1];
              }
              if (videoId != null && videoId != 'null') {
                this.youtube_id = videoId;
              }
              return _context2.a(2, this);
            case 2:
              if (this.app.BROWSER) {
                _context2.n = 4;
                break;
              }
              if (!(fetch_open_graph == 1 || !((_this$tx$optional3 = this.tx.optional) !== null && _this$tx$optional3 !== void 0 && _this$tx$optional3.link_properties))) {
                _context2.n = 4;
                break;
              }
              _context2.n = 3;
              return this.app.server.fetchOpenGraphProperties(this.link);
            case 3:
              res = _context2.v;
              if (res !== '') {
                this.tx.optional.link_properties = res;
                this.mod.updateSavedTweet(this.tx.signature);
              }
            case 4:
              return _context2.a(2, this);
          }
        }, _callee2, this);
      }));
      function analyseTweetLinks() {
        return _analyseTweetLinks.apply(this, arguments);
      }
      return analyseTweetLinks;
    }() // like, retweet, comment
  }, {
    key: "refreshStat",
    value: function refreshStat(stat, newCount) {
      // some edge cases where tweet won't have rendered
      try {
        var qs = ".tweet-".concat(this.tx.signature, " .tweet-body .tweet-controls .tweet-tool-").concat(stat, " .tweet-tool-").concat(stat, "-count");
        Array.from(document.querySelectorAll(qs)).forEach(function (obj) {
          obj.innerHTML = newCount;
        });
      } catch (err) {
        console.error("RS.Tweet -- Stat ERROR: " + err);
      }
    }
  }, {
    key: "editTweet",
    value: function editTweet() {
      var post = new Post(this.app, this.mod, this);
      post.type = 'Edit';
      post.render();
    }
  }, {
    key: "deleteTweet",
    value: function deleteTweet() {
      var post = new Post(this.app, this.mod, this);
      post.deleteTweet();
    }
  }]);
}();
module.exports = Tweet;